import React from 'react'
import { FBPage } from 'components/FbUI/Page/FBPage'
import {
  FBPageHeader,
  FBPageTableContainer,
  FBPageTitle,
  FBPageTitleRow,
} from 'components/FbUI/Page/styles'
import { BrandsTable } from 'components/Tables/BrandsTable/BrandsTable'

/** Brand management page accessible from Workspace nav. */
export const BrandsPage: React.FC = () => {
  return (
    <FBPage>
      <FBPageHeader>
        <FBPageTitleRow>
          <FBPageTitle>Brands</FBPageTitle>
        </FBPageTitleRow>
      </FBPageHeader>

      <FBPageTableContainer>
        <BrandsTable tableKey="brands-page-table" />
      </FBPageTableContainer>
    </FBPage>
  )
}
